import { render, staticRenderFns } from "./ZhanhuiRankedByJbcg.vue?vue&type=template&id=1b8fdb1e&scoped=true"
import script from "./ZhanhuiRankedByJbcg.vue?vue&type=script&lang=js"
export * from "./ZhanhuiRankedByJbcg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8fdb1e",
  null
  
)

export default component.exports